import { useEffect, useState } from "react";
import { useLocation } from "@reach/router";

import { PROFILE } from "../../mock-data/profile";
import { mockApiLoadTime } from "../../utils/misc/mock-api-load-time";

const INITIAL_PROFILE_STATE = {
  loading: true,
  profile: null,
};

/**
 * @returns {obj}
 */
function useMyProfile() {
  const [profileData, setProfileData] = useState(INITIAL_PROFILE_STATE);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!profileData.profile) {
      fetchMyProfile(setProfileData, pathname);
    }
  }, [profileData, setProfileData, pathname]);

  return {
    ...profileData,
  };
}

/**
 * @param {func} setProfileData
 * @param {string} pathname
 *
 * @returns {Promise}
 */
async function fetchMyProfile(setProfileData, pathname) {
  try {
    await mockApiLoadTime(pathname.includes("profile") ? 1500 : 500);
    setProfileData({ loading: false, profile: PROFILE });
  } catch (e) {
    setProfileData({ loading: false, profile: null });
  }
}

export default useMyProfile;
